/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
const CGU = () => {
	const navigate = useNavigate();

	useEffect(() => {
		navigate('/cgu/fr');
	}, []);

	/* ******************************** RENDERING ******************************* */
	return null;
};

export default CGU;
